import { AdminUserResponse } from "./AdminUserResponse";

export interface AdminAuthSuccessResponse {
  user: AdminUserResponse;
  token: string;
  token_expires_at?: string;
  recovery_codes?: string[];
}

export interface AdminTwoFactorSetupRequiredResponse {
  two_factor_setup_required: true;
  setup_token: string;
  expires_at: string;
  user: AdminUserResponse;
}

export interface AdminTwoFactorRequiredResponse {
  two_factor_required: true;
  challenge_token: string;
  expires_at: string;
  user: AdminUserResponse;
}

export interface AdminTwoFactorSetupResponse {
  secret: string;
  otpauth_uri: string;
}

export type AdminLoginResponse =
  | AdminAuthSuccessResponse
  | AdminTwoFactorSetupRequiredResponse
  | AdminTwoFactorRequiredResponse;

export const isAdminAuthSuccessResponse = (
  response: AdminLoginResponse | AdminAuthSuccessResponse,
): response is AdminAuthSuccessResponse => {
  return "token" in response;
};

export const isAdminTwoFactorSetupRequiredResponse = (
  response: AdminLoginResponse,
): response is AdminTwoFactorSetupRequiredResponse => {
  return "two_factor_setup_required" in response;
};

export const isAdminTwoFactorRequiredResponse = (
  response: AdminLoginResponse,
): response is AdminTwoFactorRequiredResponse => {
  return "two_factor_required" in response;
};
